import React from "react";
import ReactDOM from "react-dom/client";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAZx5FQrEV9ugPxojsjByNYz-g2Vg0JaMo",
  authDomain: "app-lia.firebaseapp.com",
  projectId: "app-lia",
  storageBucket: "app-lia.appspot.com",
  messagingSenderId: "585019803318",
  appId: "1:585019803318:web:54ad79e80ef154ea680817",
  measurementId: "G-KQD5063DTN"
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

function createMetaTag(property: string, content: string): HTMLMetaElement {
  const metaTag = document.createElement("meta");
  metaTag.setAttribute("property", property);
  metaTag.setAttribute("content", content);

  return metaTag;
}

// SEGURIDAD (open-redirect / XSS): el `url` de un doc `short_links` es atacable
// (las reglas de Firestore son world-writable), y el destino se sirve bajo el
// dominio de CONFIANZA `redirect.neuralialabs.com`. Sin validar el esquema, un
// `javascript:`/`data:` en `url` ejecutaba script en ese origen (XSS
// almacenado). Solo se sigue http(s); cualquier otra cosa cae al destino
// seguro.
function isSafeHttpUrl(raw: unknown): raw is string {
  if (typeof raw !== "string" || raw.length === 0) {
    return false;
  }

  try {
    const parsed = new URL(raw);

    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

function resolveLink(): void {
  const id =
    !!window && !!window.location && !!window.location.pathname
      ? window.location.pathname.substr(1)
      : "";
  db.collection("short_links")
    .doc(!!id && !!id.length ? id : "none")
    .get()
    .then(async (doc) => {
      if (doc.exists) {
        await doc.ref.update({ views: Number(doc.data()?.views ?? 0) + 1 });

        const target = doc?.data?.()?.url;

        if (isSafeHttpUrl(target)) {
          const head = document.head;
          head.appendChild(createMetaTag("og:image", target));
          head.appendChild(createMetaTag("og:url", target));

          window.location.href = target;
        } else {
          // Destino no http(s) o ausente: no se redirige al valor atacable.
          window.location.href = "https://neuralialabs.com";
        }
      } else {
        // Redirect to google
        window.location.href = "https://neuralialabs.com";
      }
    });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

resolveLink();

root.render(<React.StrictMode></React.StrictMode>);
